import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { cartographyApi } from 'src/Services/API';
import { ApiError } from 'src/types/api-error.types';
import { CartographySummaryDto } from 'src/types/cartography.types';

const useFetchCartographySummary = () => {
  const assetId = useCurrentAssetId();

  return useQuery<CartographySummaryDto, AxiosError<ApiError>>({
    queryKey: ['fetch-cartography-summary', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return cartographyApi.getSummary(assetId);
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchCartographySummary;
